module.exports = __webpack_public_path__ + "img/m3.c2036956.png";